import React, { useEffect, useState } from 'react';
import ReactEcharts from 'echarts-for-react';
import API from '../../../api'; // Update this import

const StatistiqueAvoirFrs = () => {
    const [etatFacturationValues, setEtatFacturationValues] = useState({
    });

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await API.post('fournisseur/facture/get_stat_facture');
                const data = response.data.FactureFrs;
                setEtatFacturationValues({
                    total_facture_direct: parseFloat(data.pourcentageFactureDirect),
                    facture_bl: parseFloat(data.pourcentageBl),
                    facture_avoir: parseFloat(data.pourcentageAvoir),
                    totalFact: parseFloat(data.totalFact),
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        fetchData();
    }, []);

    const getOptionFacturation = () => {
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: "item",
                formatter: "{a} <br/>{b}: {c} ({d}%)",
            },
            legend: {
                orient: "vertical",
                x: "left",
                data: ["Facture Avoir", "Total des factures"],
                textStyle: {
                    color: ["#74788d"],
                },
            },
            color: ["#02a499", "#f8b425", "#ec4561", "#38a4f8", "#3c4ccf"],
            series: [
                {
                    name: "Total sales",
                    type: "pie",
                    radius: ["50%", "70%"],
                    avoidLabelOverlap: false,
                    label: {
                        normal: {
                            show: false,
                            position: "center",
                        },
                        emphasis: {
                            show: true,
                            textStyle: {
                                fontSize: 30,
                                fontWeight: "bold",
                            },
                        },
                    },
                    labelLine: {
                        normal: {
                            show: false,
                        },
                    },
                    data: [
                        { value: etatFacturationValues.facture_avoir, name: 'Facture Avoir' },
                        { value: etatFacturationValues.totalFact - etatFacturationValues.facture_avoir, name: 'Total des factures' },
                    ],
                },
            ],
        };
    };


    return (
        <React.Fragment>
            <p>Facture Avoir</p>
            <ReactEcharts style={{ height: '350px' }} option={getOptionFacturation()} />
        </React.Fragment>
    );
};

export default StatistiqueAvoirFrs;
